import { render, staticRenderFns } from "./BuyAndSell.vue?vue&type=template&id=0e44d559"
import script from "./BuyAndSell.vue?vue&type=script&lang=js"
export * from "./BuyAndSell.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports